import { useTheme } from '@emotion/react';
import {
  AccountTreeOutlined,
  CloudOutlined,
  DesignServicesOutlined,
  HorizontalSplit,
} from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import HowItem from './HowItem';

import devops from '../../assets/devops.svg';

const items = [
  {
    id: 1,
    icon: CloudOutlined,
    title: 'Cloud First',
    description:
      'Wir stellen all unsere Anwendungen primär als Cloud-Lösungen bereit. So stellen wir sicher, dass die Produkte stets auf dem aktuellsten Stand sind.',
  },
  {
    id: 2,
    icon: AccountTreeOutlined,
    title: 'DevOps',
    description:
      'Durch automatisierte Tests und Continuous Deployment stellen wir unsere Agilität und die Qualität unserer Software sicher.',
  },
  {
    id: 3,
    icon: HorizontalSplit,
    title: 'Technologiestack',
    description:
      'Unser Technologiestack umfasst node.js, React, Docker und MongoDB. So können wir hochverfügbare, nutzerfreundliche Webanwendungen bereitstellen.',
  },
  {
    id: 4,
    icon: DesignServicesOutlined,
    title: 'Codemeta Services',
    description:
      'Wir haben eigene Dienste für häufig benötigte Komponenten entwickelt. Diese umfassen einen OAuth2-Login, eine individualisierbare REST API und ein flexibles Prozessmodul.',
  },
];

export default function How() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: '150px',
        width: '95%',
        pr: '100px',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column-reverse',
          width: '80%',
          pr: 0,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          minWidth: '200px',
          pr: '50px',
          width: '50%',
          [theme.breakpoints.down('md')]: {
            width: '100%',
            pt: '50px',
          },
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
        }}
      >
        <img src={devops} alt="DevOps Illustration" style={{ width: '100%' }} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: '400px',
          width: '50%',
          maxWidth: '600px',
          [theme.breakpoints.down('md')]: {
            minWidth: '100%',
          },
        }}
      >
        <Box>
          <Typography
            sx={{
              display: 'inline',
              fontSize: '48px',
              fontWeight: '800',
              fontFamily: 'Karla, sans-serif',
              color: 'primary.main',
              [theme.breakpoints.down('sm')]: {
                fontSize: '36px',
              },
            }}
          >
            Wie{' '}
          </Typography>

          <Typography
            sx={{
              display: 'inline',
              fontSize: '48px',
              fontWeight: '800',
              fontFamily: 'Karla, sans-serif',
              color: '#000',
              [theme.breakpoints.down('sm')]: {
                fontSize: '36px',
              },
            }}
          >
            arbeiten wir?
          </Typography>
        </Box>

        <Typography
          sx={{
            mt: '12px',
            mb: '50px',
            fontSize: '16px',
            fontWeight: '400',
            fontFamily: 'Karla, sans-serif',
            color: '#1E1E1E',
          }}
        >
          Als junges Team versuchen wir Lösungen schnell und agil umzusetzen.
          Bei all unseren Produkten vertrauen wir auf moderne und skalierbare
          Lösungen.
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
          {items.map((item) => (
            <Box key={item.id}>
              <HowItem
                Icon={item.icon}
                title={item.title}
                description={item.description}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
